export default __webpack_public_path__ + "static/media/1959.9e4c42ff.png";